<template>
  <section>
    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="false"></b-loading>
    <h1 class="section-head">เพิ่มซัพพลายเออร์</h1>
    <div class="field is-horizontal">
      <a class="button is-danger is-pulled-left" @click="$router.go(-1)"><i class="fas fa-arrow-left"></i>กลับ</a>
    </div>
    <div class="column">

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ชื่อซัพพลายเออร์</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ชื่อซัพพลายเออร์" v-model="supplier.name">
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </p>
          </div>
          <div class="field-label is-normal">
            <label class="label">ชื่อผู้ติดต่อ</label>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ชื่อซัพพลายเออร์" v-model="supplier.attention">
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ที่อยู่</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ที่อยู่" v-model="supplier.address">
              <span class="icon is-small is-left">
                <i class="fas fa-map-marker-alt"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เบอร์โทรศัพท์</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เบอร์โทรศัพท์" v-model="supplier.phone">
              <span class="icon is-small is-left">
                <i class="fas fa-phone"></i>
              </span>
            </p>
          </div>

          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">E-Mail</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="E-Mail" v-model="supplier.email">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เลขผู้เสียภาษี</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เลขผู้เสียภาษี" v-model="supplier.tax_no">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>


      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">บัญชีธนาคาร</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control has-icons-left">
              <div class="select">
                <select v-model="supplier.bank_name" placeholder="โปรดเลือกธนาคาร">
                  <option v-for="(bankName, key) in bankList" :key="key" :value="bankName">{{bankName}}</option>
                </select>
                <span class="icon is-small is-left">
                  <i class="fas fa-university"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>


      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ชื่อบัญชี</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ชื่อบัญชี" v-model="supplier.bank_account_name">
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เลขที่บัญชี</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เลขที่บัญชี" v-model="supplier.bank_account_no">
              <span class="icon is-small is-left">
                <i class="fas fa-piggy-bank"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Left empty for spacing -->
        </div>
        <div class="field-body">
          <div class="field is-grouped">
            <p class="control">
              <button class="button is-primary" :class="loadingClass" v-on:click="submit">
                บันทึก
              </button>
            </p>
            <p class="control">
              <router-link class="button is-light" to="/supplier">ยกเลิก</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import Request from '@/libraries/request'
  import SupplierModel from '@/model/supplier_model'
  
  export default {
    name: "Supplier_add",
    data() {
      return {
        supplier: {
          name: "",
          address: "",
          phone: "",
          email: "",
          tax_no: "",
          bank_name: "",
          bank_account_name: "",
          bank_account_no: "",
          attention: "",
        },
        isLoading: true,
        loadingClass: "",
        bankList: [
          "กรุงเทพ จำกัด (มหาชน) BBL",
          "กรุงไทย จำกัด (มหาชน) KTB",
          "กรุงศรีอยุธยา จำกัด (มหาชน) BAY",
          "กสิกรไทย จำกัด (มหาชน) KBANK",
          "เกียรตินาคิน จำกัด (มหาชน) KK",
          "ซีไอเอ็มบี ไทย จำกัด (มหาชน) CIMBT",
          "ทหารไทย จำกัด (มหาชน) TMB",
          "ทิสโก้ จำกัด (มหาชน) TISCO",
          "ไทยพาณิชย์ จำกัด (มหาชน) SCB",
          "ธนชาต จำกัด (มหาชน) TBANK",
          "ยูโอบี จำกัด (มหาชน) UOBT",
          "แลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน) LHBANK",
          "สแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน) SCBT",
          "ไอซีบีซี (ไทย) จำกัด (มหาชน) ICBCT",
          "ซิตี้แบงก์ เอ็น.เอ. CITI" ,
          "โอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด OCBC",
          "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด HSBC",
          "เพื่อการเกษตรและสหกรณ์การเกษตร BAAC",
          "ออมสิน GSB",
          "อาคารสงเคราะห์ GHB",
          "อิสลามแห่งประเทศไทย ISBT",
        ]
      }
    },
    methods: {
      submit() {
        this.loadingClass = "is-loading";
        let data = {
          id: this.$route.params.id ? this.$route.params.id : '',
          name: this.supplier.name,
          address: this.supplier.address,
          phone: this.supplier.phone,
          email: this.supplier.email,
          tax_no: this.supplier.tax_no,
          bank_name: this.supplier.bank_name,
          bank_account_name: this.supplier.bank_account_name,
          bank_account_no: this.supplier.bank_account_no,
          attention: this.supplier.attention,
        }
        Request.post('supplier/add',data, (res) => {
          if(res.data.status){
            this.loadingClass = "";
            this.$router.push('/supplier/view/'+res.data.data.id);
          }
        });
      },
      async get_supplier() {
        if(this.$route.params.id == 'undefined'){
          this.$buefy.snackbar.open('Supplier ID not found.');
          this.$router.push('/supplier');
        }else{
          try{
            const supplier = await SupplierModel.get_supplier(this.$route.params.id);
            this.supplier = supplier;
            this.isLoading = false;   
          }catch(e){
            this.$buefy.snackbar.open(e.message);
            this.$router.push('/supplier');
          }
        }
      }
    },
    created() {
      if(this.$route.params.id){
        this.get_supplier()
      }else{
        this.isLoading = false;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Supplier/add.vue